import React, { useId, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classes from './Accordion.module.css';

interface AccordionProps {
  question: string;
  answer: string;
}

const Accordion: React.FC<AccordionProps> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  const panelId = useId();

  return (
    <div className={classes.accordion}>
      <button
        type="button"
        className={classes.question}
        aria-expanded={isOpen}
        aria-controls={panelId}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={classes.questionText}>{question}</span>
        <FontAwesomeIcon
          icon="chevron-down"
          className={`${classes.icon} ${isOpen ? classes.rotate : ''}`}
        />
      </button>
      <div id={panelId} className={classes.answer} hidden={!isOpen}>
        <p>{answer}</p>
      </div>
    </div>
  );
};

export default Accordion;
